module.exports = __webpack_public_path__ + "static/media/question6.cc04d50e.gif";